import styles from "./styles";

const ImageGrid = () => (
  <div className={styles.container}>
    <div className={styles.image1} />
    <div className={styles.image2} />
    <div className={styles.image3} />
    <div className={styles.image4} />
  </div>
);

export default ImageGrid;
